import {useEffect, useState} from "react";
import {getInventoryByProduct} from "../../api/Api";
import {Select} from "antd";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const InventoryAssignmentWidget = ({productId, refresh, onSelect, onRefresh, minQuantity, onApiFail, props}) => {
    const [inventory, setInventory] = useState([]);
    const [value, setValue] = useState(undefined);
    const [active, setActive] = useState(true);

    useEffect(() => {
        const min = (minQuantity) ? minQuantity : 1;
        getInventoryByProduct(productId).then((x) => {
            const tableData = x.map((val) => {
                return {...val, key: val.id}
            }).filter(val => val.quantity >= min);
            setInventory(tableData);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [refresh, onApiFail, productId, minQuantity]);

    const productOptions = inventory.map((val, index) => {
        const displayQuantity = fixedToDisplayUnit(val.quantity, val.unit);
        return {
            value: val,
            label:  `${displayQuantity} available, SKU: ${val.sku} `,
            key: val.id
        }
    })


    const onItemSelect = (val) => {
        setValue(val);
        if (onSelect) {
            onSelect(val)
        }
        setActive(false);
    }

    const onClick  = () => {
        setActive(true);
    }

    if (active) {
        return <Select value={value} options={productOptions} onSelect={onItemSelect} placeholder={`select inventory`}
                       popupMatchSelectWidth={false}/>
    } else {
        return <div onClick={onClick} style={{cursor: 'pointer', color: "#108ee9"}}>Assigned - {`${value.sku}`}</div>
    }
}